import React, { useEffect, useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageCarouselProps {
  images: string[];
}
export function ImageCarousel({
  images
}: ImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;
  const onTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
    setIsDragging(true);
  };
  const onTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) {
      nextSlide();
    } else if (isRightSwipe) {
      prevSlide();
    }
    setIsDragging(false);
  };
  const nextSlide = () => {
    setCurrentIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <div className="relative w-full max-w-4xl mx-auto group" data-id="element-1">
      {/* Main Carousel Container */}
      <div className="relative overflow-hidden rounded-2xl shadow-2xl aspect-[4/3] md:aspect-[16/9] bg-gray-100" onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} data-id="element-2">
        <div className="flex transition-transform duration-500 ease-out h-full" style={{
        transform: `translateX(-${currentIndex * 100}%)`
      }} data-id="element-3">
          {images.map((img, index) => <div key={index} className="w-full h-full flex-shrink-0 relative" data-id="element-4">
              <img src={img} alt={`Planner Preview ${index + 1}`} className="w-full h-full object-cover" draggable={false} data-id="element-5" />
              {/* Gradient Overlay for text readability if needed, though images look busy enough */}
            </div>)}
        </div>

        {/* Navigation Arrows (Desktop) */}
        <button onClick={prevSlide} className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all hover:scale-110 z-10 backdrop-blur-sm" aria-label="Previous slide" data-id="element-6">
          <ChevronLeft className="w-6 h-6" data-id="element-7" />
        </button>

        <button onClick={nextSlide} className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all hover:scale-110 z-10 backdrop-blur-sm" aria-label="Next slide" data-id="element-8">
          <ChevronRight className="w-6 h-6" data-id="element-9" />
        </button>

        {/* Mobile Swipe Hint */}
        <div className="md:hidden absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/30 text-white px-3 py-1 rounded-full text-xs backdrop-blur-sm pointer-events-none" data-id="element-10">
          Swipe to view
        </div>
      </div>

      {/* Dot Indicators */}
      <div className="flex justify-center mt-4 space-x-2" data-id="element-11">
        {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${currentIndex === index ? 'bg-pink-500 w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-12" />)}
      </div>
    </div>;
}